/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { sidebarStatePropType } from 'components/Sidebar/propTypes';
import {
  SINGLE_OPTION_SELECT,
  MULTIPLE_OPTION_SELECT,
  TRIPLE_QUESTION_DROP_DOWN,
  LOCATION,
  NUMBER_INPUT,
  MONTH_PICKER,
  MULTIPLE_DROP_DOWN_SELECT,
  OPTIONS_FROM_SERVER,
  MULTIPLE_OPTION_SEARCH_SELECT,
  TREATMENT_HISTORY,
  PROCEDURES,
  BIOMARKERS,
  TEXT_INPUT,
  SUB_STAGE_SELECT,
  COMPOSITE,
  SIMPLE_COMPOSITE,
  SIMPLE_OPTION_SELECT,
} from 'modules/questionnaire/questionTypes';
import SingleOptionSelect from './SingleOptionSelect';
import SubStageSelect from './SubStageSelect';
import { MultipleOptionSelect } from './MultipleOptionSelect';
import TripleQuestionDropdown from './TripleQuestionDropdown';
import LocationQuestion from './LocationQuestion';
import NumberInput from './NumberInput';
import { MultipleDropdownSelect } from './MultipleDropdownSelect';
import { MultipleOptionQuestion } from './MultipleOptionQuestion';
import { ServerMultipleOptionQuestion } from './ServerMultipleOptionQuestion';
import { MultipleCompoundQuestion } from './MultipleCompoundQuestion/MultipleCompoundQuestion';
import { MonthPicker } from './MonthPicker';
import { BiomarkersQuestion } from './BiomarkersQuestion/BiomarkersQuestion';
import TextInput from './TextInput';
import { SimpleOptionSelect } from './SimpleOptionSelect';
import { SimpleMultipleCompoundQuestion } from './SimpleMultipleCompoundQuestion';

const QuestionRenderer = (props) => {
  const { question } = props;

  switch (question.type) {
    case SUB_STAGE_SELECT:
      return <SubStageSelect {...props} />;
    case SINGLE_OPTION_SELECT:
      return <SingleOptionSelect {...props} />;
    case MULTIPLE_OPTION_SELECT:
      return <MultipleOptionSelect {...props} />;
    case TRIPLE_QUESTION_DROP_DOWN:
      // sets many answers (directly sets many question ids to questionnaire.form)
      return <TripleQuestionDropdown question={question} />;
    case LOCATION:
      return <LocationQuestion {...props} />;
    case NUMBER_INPUT:
      return <NumberInput {...props} />;
    case MONTH_PICKER:
      return <MonthPicker {...props} />;
    case MULTIPLE_DROP_DOWN_SELECT:
      return <MultipleDropdownSelect {...props} />;
    case OPTIONS_FROM_SERVER:
      return <ServerMultipleOptionQuestion {...props} />;
    case MULTIPLE_OPTION_SEARCH_SELECT:
      return <MultipleOptionQuestion {...props} />;
    // case TREATMENT_HISTORY:
      // return <TreatmentsQuestion {...props} ref={props.forwardedRef} />;
    case TREATMENT_HISTORY:
    case PROCEDURES:
    case COMPOSITE:
      return <MultipleCompoundQuestion {...props} />;
    case BIOMARKERS:
      return <BiomarkersQuestion {...props} ref={props.forwardedRef} />;
    case TEXT_INPUT:
      return <TextInput {...props} />;
    case SIMPLE_COMPOSITE:
      return <SimpleMultipleCompoundQuestion {...props} />;
    case SIMPLE_OPTION_SELECT:
      return <SimpleOptionSelect {...props} />;
    default:
      return <div />;
  }
};

QuestionRenderer.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  sidebarState: sidebarStatePropType,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  shouldNextButtonBeShown: PropTypes.bool,
  handleNextButtonClick: PropTypes.func.isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export default QuestionRenderer;
